"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customCategoryIcons = exports.Upload = exports.RectWithT = exports.Image = exports.Garbage = exports.Emoticon = exports.EditText = exports.CircleFilled = exports.Checkmark = exports.ArrowLeft = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ArrowLeft = _ref => {
  let {
    className,
    fill,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15147 12L16.5757 2.57573L17.4243 3.42426L8.84853 12L17.4243 20.5757L16.5757 21.4243L7.15147 12Z",
    fill: fill || 'black'
  }));
};
exports.ArrowLeft = ArrowLeft;
const Checkmark = _ref2 => {
  let {
    className,
    fill,
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4243 7.42427L9.50001 18.3485L3.57574 12.4243L4.42427 11.5757L9.50001 16.6515L19.5757 6.57574L20.4243 7.42427Z",
    fill: fill || 'black'
  }));
};
exports.Checkmark = Checkmark;
const CircleFilled = _ref3 => {
  let {
    className,
    fill,
    ...props
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    className: className
  }, props, {
    height: "25",
    width: "25.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "10",
    stroke: fill || '#000000',
    strokeWidth: "3",
    fill: fill || '#000000'
  }));
};
exports.CircleFilled = CircleFilled;
const EditText = _ref4 => {
  let {
    className,
    fill,
    ...props
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    version: "1.1",
    className: className
  }, props, {
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: '#000000',
    d: "M468.984,49.552h-40v16h40V49.552z M388.984,49.552h-40v16h40V49.552z M308.984,49.552h-40v16h40 V49.552z M228.984,49.552h-40v16h40V49.552z M148.984,49.552h-40v16h40V49.552z M68.984,49.552H49.552v16l0,0v4.56h16v-4.56h3.44 L68.984,49.552L68.984,49.552z M65.544,110.112h-16v40h16V110.112z M65.544,190.112h-16v40h16V190.112z M65.544,270.112h-16v40h16 V270.112z M65.544,350.112h-16v40h16V350.112z M65.544,430.112h-16v38.88h16V430.112z M130.664,452.992h-40v16h40V452.992z M210.664,452.992h-40v16h40V452.992z M290.664,452.992h-40v16h40V452.992z M370.664,452.992h-40v16h40V452.992z M450.664,452.992 h-40v16h40V452.992z M468.976,407.304h-16v40h16V407.304z M468.976,327.304h-16v40h16V327.304z M468.976,247.304h-16v40h16V247.304z M468.976,167.304h-16v40h16V167.304z M468.976,87.304h-16v40h16V87.304z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "412.904",
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    y: "412.904",
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "412.904",
    y: "412.904",
    fill: '#000000',
    width: "99.096",
    height: "99.096"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: '#000000',
    d: "M221.6,311.608l-16.28,58.672h-53.6l69.88-228.56h67.816l70.872,228.56h-55.624l-17.6-58.672H221.6z M279.584,272.952l-14.248-48.488c-4.064-13.6-8.128-30.528-11.512-44.096h-0.704c-3.392,13.6-6.784,30.856-10.512,44.096 l-13.6,48.488H279.584z"
  }), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null), /*#__PURE__*/_react.default.createElement("g", null));
};
exports.EditText = EditText;
const Emoticon = _ref5 => {
  let {
    className,
    fill,
    ...props
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.59999C7.36083 3.59999 3.60002 7.3608 3.60002 12C3.60002 16.6392 7.36083 20.4 12 20.4C16.6392 20.4 20.4 16.6392 20.4 12C20.4 7.3608 16.6392 3.59999 12 3.59999ZM2.40002 12C2.40002 6.69806 6.69809 2.39999 12 2.39999C17.302 2.39999 21.6 6.69806 21.6 12C21.6 17.3019 17.302 21.6 12 21.6C6.69809 21.6 2.40002 17.3019 2.40002 12Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52427 13.7082C8.42479 15.3264 10.0979 16.4 12 16.4C13.9021 16.4 15.5752 15.3264 16.4757 13.7082L17.5243 14.2918C16.4287 16.2604 14.3709 17.6 12 17.6C9.62905 17.6 7.57128 16.2604 6.47571 14.2918L7.52427 13.7082Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2 10C8.2 10.4418 8.55817 10.8 9 10.8C9.44183 10.8 9.8 10.4418 9.8 10C9.8 9.55817 9.44183 9.2 9 9.2C8.55817 9.2 8.2 9.55817 8.2 10ZM14.2 10C14.2 10.4418 14.5582 10.8 15 10.8C15.4418 10.8 15.8 10.4418 15.8 10C15.8 9.55817 15.4418 9.2 15 9.2C14.5582 9.2 14.2 9.55817 14.2 10ZM9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10C11 11.1046 10.1046 12 9 12ZM15 12C13.8954 12 13 11.1046 13 10C13 8.89543 13.8954 8 15 8C16.1046 8 17 8.89543 17 10C17 11.1046 16.1046 12 15 12Z",
    fill: "black"
  }));
};
exports.Emoticon = Emoticon;
const Garbage = _ref6 => {
  let {
    className,
    fill,
    ...props
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2 5.8H18.8V5.2H15.2584L14.4795 3.64223C14.344 3.3712 14.0669 3.2 13.7639 3.2H10.2361C9.93305 3.2 9.65604 3.3712 9.52053 3.64223L8.74164 5.2H5.2V5.8ZM20 7H4V5C4 4.44772 4.44772 4 5 4H8L8.44721 3.10557C8.786 2.428 9.47852 2 10.2361 2H13.7639C14.5215 2 15.214 2.428 15.5528 3.10557L16 4H19C19.5523 4 20 4.44772 20 5V7ZM19 8H5V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V8ZM17.8 9.2V20C17.8 20.4418 17.4418 20.8 17 20.8H7C6.55817 20.8 6.2 20.4418 6.2 20V9.2H17.8Z",
    fill: fill || 'black'
  }));
};
exports.Garbage = Garbage;
const Image = _ref7 => {
  let {
    className,
    fill,
    ...props
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: className
  }, props, {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.4H20C20.8837 2.4 21.6 3.11635 21.6 4V20C21.6 20.8837 20.8837 21.6 20 21.6H4.00002C3.11637 21.6 2.40002 20.8837 2.40002 20V12H3.60002V20C3.60002 20.2209 3.77911 20.4 4.00002 20.4H20C20.2209 20.4 20.4 20.2209 20.4 20V4C20.4 3.77909 20.2209 3.6 20 3.6H12V2.4Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6111 9.02564L14.0069 13.4746L15.5 11.5743L20.2345 17.6H3.75165L10.6111 9.02564ZM6.2484 16.4H17.7655L15.5 13.5166L13.9931 15.4344L10.5889 10.9744L6.2484 16.4Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 5.4V2H6.6V5.4H10V6.6H6.6V10H5.4V6.6H2V5.4H5.4Z",
    fill: fill || 'black'
  }));
};
exports.Image = Image;
const RectWithT = _ref8 => {
  let {
    className,
    fill,
    ...props
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "32",
    height: "32",
    className: className
  }, props, {
    version: "1.1"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "rgba(0, 0, 0, 0.2)"
  }), /*#__PURE__*/_react.default.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    style: {
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      background: 'transparent',
      padding: 0,
      marginTop: '-1px',
      fontSize: '18px',
      minHeight: 'unset'
    },
    xmlns: "http://www.w3.org/1999/xhtml"
  }, /*#__PURE__*/_react.default.createElement("div", null, "T")))));
};
exports.RectWithT = RectWithT;
const Upload = _ref9 => {
  let {
    className,
    fill,
    ...props
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "24",
    height: "24",
    className: className
  }, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 17.8C19.8748 17.8 21.8 15.8748 21.8 13.5C21.8 11.1252 19.8748 9.2 17.5 9.2C16.9279 9.2 16.3847 9.31109 15.8887 9.51175C15.2474 9.77115 14.5117 9.48406 14.2187 8.85253C13.2171 6.69339 11.0317 5.2 8.5 5.2C5.02061 5.2 2.2 8.02061 2.2 11.5C2.2 14.8102 4.75294 17.5241 7.9973 17.7802V18.9834C4.08956 18.7248 1 15.4732 1 11.5C1 7.35786 4.35786 4 8.5 4C11.5161 4 14.1164 5.78039 15.3073 8.34756C15.3302 8.397 15.3881 8.41976 15.4387 8.39932C16.0753 8.1418 16.7711 8 17.5 8C20.5376 8 23 10.4624 23 13.5C23 16.5376 20.5376 19 17.5 19H16.0002V17.8H17.5Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 23L11.4 15L12.6 15L12.6 23L11.4 23Z",
    fill: fill || 'black'
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15L15 15L12 12L9 15Z",
    fill: fill || 'black'
  }));
};
exports.Upload = Upload;
const customCategoryIcons = {
  frequent: {
    svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 7H12L12 12H17V14H10L10 7Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z" fill="currentColor"/>
        </svg>`
  },
  people: {
    svg: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.2083 10.8334H12.5416C12.5416 11.7539 11.7954 12.5001 10.875 12.5001C9.95449 12.5001 9.20829 11.7539 9.20829 10.8334H7.54163C7.54163 12.6744 9.03401 14.1667 10.875 14.1667C12.7159 14.1667 14.2083 12.6744 14.2083 10.8334Z" fill="currentColor"/>
        <path d="M9.20829 8.33342C9.20829 8.79365 8.8352 9.16675 8.37496 9.16675C7.91472 9.16675 7.54163 8.79365 7.54163 8.33342C7.54163 7.87318 7.91472 7.50008 8.37496 7.50008C8.8352 7.50008 9.20829 7.87318 9.20829 8.33342Z" fill="currentColor"/>
        <path d="M13.375 9.16675C13.8352 9.16675 14.2083 8.79365 14.2083 8.33342C14.2083 7.87318 13.8352 7.50008 13.375 7.50008C12.9147 7.50008 12.5416 7.87318 12.5416 8.33342C12.5416 8.79365 12.9147 9.16675 13.375 9.16675Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2083 10.0001C19.2083 14.6025 15.4773 18.3334 10.875 18.3334C6.27259 18.3334 2.54163 14.6025 2.54163 10.0001C2.54163 5.39771 6.27259 1.66675 10.875 1.66675C15.4773 1.66675 19.2083 5.39771 19.2083 10.0001ZM17.5416 10.0001C17.5416 13.682 14.5569 16.6667 10.875 16.6667C7.19306 16.6667 4.20829 13.682 4.20829 10.0001C4.20829 6.31818 7.19306 3.33341 10.875 3.33341C14.5569 3.33341 17.5416 6.31818 17.5416 10.0001Z" fill="currentColor"/>
        </svg>`
  },
  nature: {
    svg: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8668 13.5988C10.2792 14.2606 9.48402 14.7339 8.58337 14.9167V17.5001C8.58337 17.9603 8.21028 18.3334 7.75004 18.3334C7.2898 18.3334 6.91671 17.9603 6.91671 17.5001V14.9167C5.01484 14.5307 3.58337 12.8492 3.58337 10.8334L3.58337 5.83342C3.58337 3.53223 5.44885 1.66675 7.75004 1.66675C9.92396 1.66675 11.709 3.33159 11.8998 5.45585C12.3939 5.16616 12.9692 5.00008 13.5834 5.00008C15.4243 5.00008 16.9167 6.49247 16.9167 8.33342V11.6667C16.9167 13.2199 15.8544 14.525 14.4167 14.8951V17.5001C14.4167 17.9603 14.0436 18.3334 13.5834 18.3334C13.1231 18.3334 12.75 17.9603 12.75 17.5001V14.8951C11.979 14.6966 11.3159 14.2292 10.8668 13.5988ZM10.25 5.83342V10.8334C10.25 11.9219 9.55437 12.848 8.58337 13.1912L8.58337 10.8334C8.58337 10.3732 8.21028 10.0001 7.75004 10.0001C7.2898 10.0001 6.91671 10.3732 6.91671 10.8334V13.1912C5.94571 12.848 5.25004 11.9219 5.25004 10.8334L5.25004 5.83342C5.25004 4.4527 6.36933 3.33341 7.75004 3.33341C9.13075 3.33341 10.25 4.4527 10.25 5.83342ZM14.4167 13.1104V10.8334C14.4167 10.3732 14.0436 10.0001 13.5834 10.0001C13.1231 10.0001 12.75 10.3732 12.75 10.8334V13.1104C12.2519 12.8223 11.9167 12.2837 11.9167 11.6667L11.9167 8.33342C11.9167 7.41294 12.6629 6.66675 13.5834 6.66675C14.5038 6.66675 15.25 7.41294 15.25 8.33342L15.25 11.6667C15.25 12.2837 14.9149 12.8223 14.4167 13.1104Z" fill="currentColor"/>
        </svg>
        `
  },
  foods: {
    svg: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.62504 2.08325C5.1648 2.08325 4.79171 2.45635 4.79171 2.91659V4.58325C4.79171 5.04349 5.1648 5.41659 5.62504 5.41659C6.08528 5.41659 6.45837 5.04349 6.45837 4.58325V2.91659C6.45837 2.45635 6.08528 2.08325 5.62504 2.08325Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4584 17.9166C13.9359 17.9166 15.9925 16.1147 16.3892 13.7499H16.4584C18.2993 13.7499 19.7917 12.2575 19.7917 10.4166C19.7917 8.57564 18.2993 7.08325 16.4584 7.08325V6.24992H1.45837V12.9166C1.45837 15.678 3.69695 17.9166 6.45837 17.9166H11.4584ZM3.12504 7.91658V12.9166C3.12504 14.7575 4.61742 16.2499 6.45837 16.2499H11.4584C13.2993 16.2499 14.7917 14.7575 14.7917 12.9166V7.91658H3.12504ZM18.125 10.4166C18.125 11.3371 17.3788 12.0833 16.4584 12.0833V8.74992C17.3788 8.74992 18.125 9.49611 18.125 10.4166Z" fill="currentColor"/>
        <path d="M8.12504 2.91659C8.12504 2.45635 8.49814 2.08325 8.95837 2.08325C9.41861 2.08325 9.79171 2.45635 9.79171 2.91659V4.58325C9.79171 5.04349 9.41861 5.41659 8.95837 5.41659C8.49814 5.41659 8.12504 5.04349 8.12504 4.58325V2.91659Z" fill="currentColor"/>
        <path d="M12.2917 2.08325C11.8315 2.08325 11.4584 2.45635 11.4584 2.91659V4.58325C11.4584 5.04349 11.8315 5.41659 12.2917 5.41659C12.7519 5.41659 13.125 5.04349 13.125 4.58325V2.91659C13.125 2.45635 12.7519 2.08325 12.2917 2.08325Z" fill="currentColor"/>
        </svg>
        `
  },
  activity: {
    svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711C8.83418 22.9763 15.1658 22.9763 19.0711 19.0711ZM19.9426 11.0407C19.7364 9.32374 18.9745 7.6608 17.6569 6.34315C16.3343 5.0206 14.6639 4.25792 12.9402 4.0551L12.93 4.11139C12.1086 8.58308 8.58304 12.1086 4.11136 12.93L4.05511 12.9402C4.25793 14.6639 5.02061 16.3343 6.34315 17.6569C7.66079 18.9745 9.32373 19.7364 11.0407 19.9426C11.0449 19.9191 11.0491 19.8956 11.0534 19.8721C11.8748 15.4004 15.4003 11.8748 19.872 11.0534C19.8955 11.0491 19.9191 11.0449 19.9426 11.0407ZM19.872 13.4292V13.0951C16.5073 13.8586 13.8586 16.5073 13.095 19.8721H13.429C14.9777 19.5924 16.4598 18.8539 17.6569 17.6569C18.8539 16.4598 19.5923 14.9778 19.872 13.4292ZM4.11136 10.8884L4.11136 10.666C4.37766 9.08301 5.12159 7.5647 6.34315 6.34315C7.56465 5.12165 9.08288 4.37773 10.6658 4.11139L10.8883 4.11139C10.1248 7.47615 7.47612 10.1249 4.11136 10.8884Z" fill="currentColor"/>
        </svg>
        `
  },
  places: {
    svg: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9351 8.56002C13.9351 10.401 12.4427 11.8934 10.6018 11.8934C8.76084 11.8934 7.26845 10.401 7.26845 8.56002C7.26845 6.71907 8.76084 5.22669 10.6018 5.22669C12.4427 5.22669 13.9351 6.71907 13.9351 8.56002ZM12.2685 8.56002C12.2685 9.48049 11.5223 10.2267 10.6018 10.2267C9.68131 10.2267 8.93512 9.48049 8.93512 8.56002C8.93512 7.63954 9.68131 6.89335 10.6018 6.89335C11.5223 6.89335 12.2685 7.63954 12.2685 8.56002Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.20347 13.7651C2.20354 10.909 2.08699 6.16166 4.94315 3.16172C7.79931 0.161788 12.5466 0.0452378 15.5466 2.9014C18.5465 5.75757 18.663 10.5049 15.8069 13.5048L10.6353 18.9367L5.20347 13.7651ZM14.5998 12.3556L10.5775 16.5804L6.3527 12.558C4.01942 10.3366 3.92877 6.64424 6.15023 4.31096C8.37169 1.97767 12.064 1.88702 14.3973 4.10848C16.7306 6.32994 16.8213 10.0223 14.5998 12.3556Z" fill="currentColor"/>
        </svg>
        `
  },
  objects: {
    svg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 9C4 11.9611 5.60879 14.5465 8 15.9297V15.9999C8 18.2091 9.79086 19.9999 12 19.9999C14.2091 19.9999 16 18.2091 16 15.9999V15.9297C18.3912 14.5465 20 11.9611 20 9C20 4.58172 16.4183 1 12 1C7.58172 1 4 4.58172 4 9ZM16 13.4722C17.2275 12.3736 18 10.777 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 10.777 6.7725 12.3736 8 13.4722L10 13.4713V16C10 17.1045 10.8954 17.9999 12 17.9999C13.1045 17.9999 14 17.1045 14 15.9999V13.4713L16 13.4722Z" fill="currentColor"/>
        <path d="M10 21.0064V21C10.5883 21.3403 11.2714 21.5351 12 21.5351C12.7286 21.5351 13.4117 21.3403 14 21V21.0064C14 22.111 13.1046 23.0064 12 23.0064C10.8954 23.0064 10 22.111 10 21.0064Z" fill="currentColor"/>
        </svg>
        `
  },
  symbols: {
    svg: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4583 5.0008C18.4583 2.95785 16.6373 1.39558 14.6181 1.70622L8.78477 2.60366C7.15866 2.85383 5.95829 4.253 5.95829 5.89823V13.2007C5.57944 13.0207 5.15562 12.92 4.70829 12.92C3.09746 12.92 1.79163 14.2258 1.79163 15.8367C1.79163 17.4475 3.09746 18.7533 4.70829 18.7533C6.31909 18.7533 7.62491 17.4476 7.62496 15.8368V5.89823C7.62496 5.07561 8.22514 4.37603 9.0382 4.25095L14.8715 3.35351C15.8811 3.19819 16.7916 3.97932 16.7916 5.0008V10.7007C16.4128 10.5207 15.989 10.42 15.5416 10.42C13.9308 10.42 12.625 11.7258 12.625 13.3367C12.625 14.9475 13.9308 16.2533 15.5416 16.2533C17.1524 16.2533 18.4582 14.9476 18.4583 13.3368V5.0008ZM16.7916 13.3367C16.7916 12.6463 16.232 12.0867 15.5416 12.0867C14.8513 12.0867 14.2916 12.6463 14.2916 13.3367C14.2916 14.027 14.8513 14.5867 15.5416 14.5867C16.2319 14.5867 16.7916 14.027 16.7916 13.3367ZM5.95829 15.8367C5.95829 15.1463 5.39865 14.5867 4.70829 14.5867C4.01794 14.5867 3.45829 15.1463 3.45829 15.8367C3.45829 16.527 4.01794 17.0867 4.70829 17.0867C5.39862 17.0867 5.95824 16.527 5.95829 15.8367Z" fill="currentColor"/>
        </svg>
        `
  },
  flags: {
    svg: `<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.83337 17.5H5.50004V9.16667H10.5V10.8333H17.1667V4.16667H11.3334V2.5H3.83337V17.5ZM10.5 4.16667H5.50004V7.5H11.3334V9.16667H15.5V5.83333H10.5V4.16667Z" fill="currentColor"/>
        </svg>
        `
  }
};
exports.customCategoryIcons = customCategoryIcons;
//# sourceMappingURL=icons.js.map